import React from 'react'
import styled from '@emotion/styled'

import { layout, colors } from 'Constants'

import { Flex } from 'lese'

import NavBar from './components/NavBar'
import Modal from 'Components/Modal'

const Base = styled.div`
  background-color: ${colors.background};
  color: ${colors.text};
  min-height: 100vh;
  @media print {
    font-size: 0.7rem;
  }
`

export default ({ children }) => (
  <Base>
    <Modal />
    <NavBar />
    <Flex
      column
      xAlign="stretch"
      width={layout.maxWidth}
      responsive
      style={{ margin: 'auto', padding: '24px', boxSizing: 'border-box' }}
      separation="24px"
    >
      {children}
    </Flex>
  </Base>
)
